// extracted by mini-css-extract-plugin
module.exports = {"Root":"ResultList_Root__3h1XH","Results":"ResultList_Results__3yJss"};